<div class="pt-2 pt-md-0 pb-2 pb-md-5" data-e2e="contract-item">
  @if (icon) {
  <div>
    <img alt="" [src]="icon" />
  </div>
  }
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <h3 class="mb-0" data-e2e="item-title">{{activeContractViewModel?.offerName}}</h3>
      @if (activeContractViewModel?.member) {
      <div class="text-smagenta1 font-weight-bold" data-e2e="item-member">
        {{activeContractViewModel.member.displayName}}
      </div>
      }
      <div class="lead text-gray3 py-0" data-e2e="item-offer">{{activeContractViewModel?.detail}}</div>
      @if (activeContractViewModel?.delegation) {
      <div class="lead text-gray3 py-0" data-e2e="item-holder">
        {{"dashboard.contractsAndOptions.delegation" | translate}}{{activeContractViewModel.delegation}}
      </div>
      } @if (activeContractViewModel?.installationCity) {
      <div class="lead text-gray3 py-0" data-e2e="item-installation-city">
        {{activeContractViewModel.installationCity}}
      </div>
      } @if (!isVimEligible && activeContractViewModel !== null && activeContractViewModel.isFamilyEligible &&
      !activeContractViewModel.member) {
      <a
        [href]='"dashboard.contractsAndOptions.whoUseContract.link" | translate | link: ParamsUtils.cidMap(activeContractViewModel.cid) | async'
        (click)="openWhoUseContract();false"
        class="o-link-arrow"
        data-e2e="whoUseContract"
      >
        {{"dashboard.bills.whoUseContract.label" | translate}}</a
      >
      } @if (activeContractViewModel?.koContract && !activeContractViewModel?.koContract?.hideButtonKoContract) {
      <div class="alert-item alert-container alert-warning mt-2" role="alert">
        <p class="alert">
          <span class="alert-icon icon-Warning-important" aria-hidden="true"></span>
          <span class="text-mw">{{activeContractViewModel?.koContract?.textKoContract}}</span>
        </p>
      </div>
      }
    </div>
    @if (activeContractViewModel?.koContract?.hideButtonKoContract) {
    <div class="alert-item alert-container" [ngClass]="this.alertTheme" role="alert">
      <p class="alert">
        <span class="alert-icon" [ngClass]="this.iconTheme" aria-hidden="true"></span>
        <span class="text-mw">{{activeContractViewModel.koContract.textKoContract}}</span>
      </p>
      @if (activeContractViewModel.koContract.linkLabel) {
      <div class="alert-content">
        <a
          [href]="activeContractViewModel.koContract.link | link | async"
          (click)="openInprogressLink();false"
          class="o-link-arrow"
          >{{inprogressLinkLabel}}</a
        >
      </div>
      }
    </div>
    } @if (!activeContractViewModel?.koContract || !activeContractViewModel?.koContract?.hideButtonKoContract) { @if
    (activeContractViewModel?.type !== 'fixe') {
    <div class="col-12 col-md-6 col-lg-7 mt-2 mt-md-0">
      <div>
        <a
          class="btn btn-secondary d-none d-md-block"
          [href]="openContractLink | link: ParamsUtils.cidMap(activeContractViewModel.cid) | async"
          (click)="openContract();false"
          data-e2e="item-link"
        >
          {{labelButton}}
        </a>
      </div>
      <div class="item mt-1">
        <ul class="items-list">
          @if (activeContractViewModel?.suspendedContract) {
          <crossroadSuspendedAlert
            [viewModel]="activeContractViewModel.suspendedContract"
            [cid]="activeContractViewModel.cid"
          ></crossroadSuspendedAlert>
          } @if (activeContractViewModel.familyAdvantages) {
          <li>
            <picto-sub-item data-e2e="family-advantages" [viewModel]="activeContractViewModel.familyAdvantages">
            </picto-sub-item>
          </li>
          } @if (activeContractViewModel?.contractReco) {
          <li>
            <commercial-sub-item
              data-e2e="contractReco"
              [viewModel]="activeContractViewModel.contractReco"
            ></commercial-sub-item>
          </li>
          }
        </ul>
      </div>
      <div class="d-flex justify-content-center d-md-none">
        <a
          class="btn btn-secondary mt-2"
          [href]="openContractLink | link: ParamsUtils.cidMap(activeContractViewModel.cid) | async"
          (click)="openContract();false"
          data-e2e="item-link"
        >
          {{labelButton}}
        </a>
      </div>
    </div>
    } @if (activeContractViewModel?.type === 'fixe') {
    <div class="col-md-6 col-lg-7 mt-md-0 d-md-block d-none">
      <a
        class="btn btn-secondary"
        [href]="openContractLink | link: ParamsUtils.cidMap(activeContractViewModel.cid) | async"
        (click)="openContract();false"
      >
        {{"dashboard.contractsAndOptions.button.offerAndOptions.label" | translate}}
      </a>
    </div>
    <div class="standard col-12 d-md-none mt-2">{{"dashboard.contractsAndOptions.landLineMessage" | translate}}</div>
    } }
  </div>
</div>
